import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiBaseService } from 'src/app/shared/services/api/api-base/api-base.service';

@Injectable()
export class LearningPlayerCoreService {
  constructor(private _api: ApiBaseService) {}

  public getLearningPlayerLeaderboard(
    divisionId: string,
    includeNonPostive?: boolean,
    maxRank = 10000,
  ): Observable<ILearningPlayerRank[]> {
    const query: ILearningPlayerLeaderboardQuery = {
      maxRank: maxRank || 10000,
      divisionId,
      includeNonPostive,
    };

    return this._api.get(`learning-players/leaderboard`, query);
  }
}

export interface ILearningPlayerRank {
  _id: string;
  learnerId: string;
  divisionId: string;
  firstName: string;
  lastName: string;
  highestScore: number;
  rank: number;
  extraDetail: any;
  highestScoreHistory: number;
  highestScoreDetailsHistory: ISectionScore[];
  updatedAt: Date | string;
  completedAt: Date | string;
}

export interface ILearningPlayerLeaderboardQuery {
  limit?: number;
  skip?: number;
  divisions?: string;
  search?: string;
  divisionId?: string;
  maxRank?: number;
  includeNonPostive?: boolean;
}

export interface IValuesPlayerLeaderboardQuery
  extends ILearningPlayerLeaderboardQuery {
  valuesGameId: string;
  scorePosition: string;
}
export interface ISectionScore {
  actualScore: number;
  targetScore: number;
  _id: string;
  sectionName: string;
}
